import { Box, Link } from '@mui/material';
import { useEffect, useRef } from 'react';

import config from '@/config';
import { urls } from '@/constants';
import { AnalyticsService, EVENTS } from '@/services';
import { selectUserRegion, useAppSelector } from '@/store';

export const TrustPilotWidget = () => {
  const ref = useRef(null);
  const region = useAppSelector(selectUserRegion);

  useEffect(() => {
    AnalyticsService.logEvent(EVENTS.PRODUCT_FEEDBACK_EVENTS.TRUSTPILOT);

    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      ref={ref}
      className="trustpilot-widget"
      data-template-id={config.TRUSTPILOT_TEMPLATE_ID}
      data-businessunit-id={config.TRUSTPILOT_BUSINESSUNIT_ID}
      data-token={config.TRUSTPILOT_TOKEN}
      data-locale="en-US"
      data-style-height="80px">
      <Link
        sx={{ my: 2 }}
        href={urls.trustPilot[region]}
        target="_blank"
        rel="noopener noreferrer">
        Rate us on Trustpilot
      </Link>
    </Box>
  );
};
